import debounce from "lodash/debounce";

import type { CustomField } from "../../types/customFields";
import ErrorMessage from "../ErrorMessage";
import Input, { Field } from "../Input";
import { Label } from "../Label";

export function TextField({
  fieldId,
  customField,
  fieldValues,
  isReadOnly,
  isRequired,
  error,
  isDebounce,
  onChange,
}: {
  customField: CustomField;
  error?: string;
  fieldId: string;
  fieldValues: CustomField["defaultValues"];
  isDebounce?: boolean;
  isReadOnly: boolean;
  isRequired?: boolean;
  onChange: (
    fieldId: string,
    customField: CustomField,
    value: CustomField["defaultValues"],
    groupId: string,
  ) => void;
}) {
  const onChangeHander = (value: string) => {
    onChange(
      fieldId,
      customField,
      [
        {
          isSelected: false,
          value,
        },
      ],
      customField.groupId,
    );
  };

  const debouncedOnChangeHandler = debounce(onChangeHander, 1000);

  const errorId = `${fieldId}-error`;

  return (
    <Field>
      <Label required={isRequired}>{customField.name}</Label>
      <Input
        defaultValue={
          fieldValues.length ? String(fieldValues[0].value) : undefined
        }
        toolTipText={customField.helpText}
        type="text"
        readOnly={isReadOnly}
        onChange={isDebounce ? debouncedOnChangeHandler : onChangeHander}
        required={isRequired}
        invalid={!!error}
        aria-invalid={!!error}
        aria-describedby={error ? errorId : undefined}
      />
      {error && <ErrorMessage id={errorId} message={error} />}
    </Field>
  );
}
